<template>
  <div class="calendar__month-card-work-icon" :class="{ 'work': item.restType === 2, 'rest': item.restType === 3 }">
    {{item.restType === 2 ? '班' : '休'}}
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="stylus" scoped>
.calendar__month-card-work-icon {
    width: 18px;
    height: 18px;
    background: #BFC0CA;
    border-radius: 2px;
    color: #FFFFFF;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    position: absolute;
    right: 30px;

    &.rest {
      background: #FA9A2A;
    }
}
</style>
